import { type FC } from "react";
import { useTranslation } from "react-i18next";
import { Card, CardContent, Stack, Typography, Box } from "@mui/material";
import moment from "moment";
import type { ObjectItem, SelectObjectTypeConfig } from "../types";
import { ItemComponent } from "./ItemComponent";

// Тот же формат, что и "short" в interpolationFormat (партнёрские списки,
// cabinet/src/partner/shared/lib/interpolationFormat.ts) — этот компонент
// живёт в общем shared-слое (потенциально доступен и admin, и partner), а
// граница src/shared/** запрещает импорт из @/partner/**
// (eslint.boundaries.mjs), поэтому формат воспроизведён локально, а не
// заимпортирован.
const formatItemDate = (value: string, locale: string): string =>
  moment(value).locale(locale).format("DD MMMM YYYY");

export interface SelectObjectListItemProps {
  item: ObjectItem;
  config: SelectObjectTypeConfig;
  selected: boolean;
  onSelect: () => void;
}

export const SelectObjectListItem: FC<SelectObjectListItemProps> = ({
  item,
  config,
  selected,
  onSelect,
}) => {
  const { t, i18n } = useTranslation();
  const hasDate = item.publishAt || item.createdAt;

  return (
    <Card
      onClick={onSelect}
      sx={{
        cursor: "pointer",
        backgroundColor: selected ? "primary.main" : undefined,
        "&:hover": {
          backgroundColor: selected ? "primary.dark" : "action.hover",
        },
      }}
    >
      <CardContent>
        <Stack direction="row" alignItems="center" spacing={2} useFlexGap>
          <ItemComponent item={item} config={config} />

          <Box sx={{ marginLeft: "auto", flexShrink: 0 }}>
            {hasDate ? (
              <Box>
                <Typography variant="body2" color="text.primary" align="right">
                  {item.publishAt
                    ? t("shared.selectObject.published", {
                        defaultValue: "Опубликовано",
                      })
                    : t("shared.selectObject.created", {
                        defaultValue: "Создано",
                      })}
                </Typography>
                <Typography
                  variant="body2"
                  color="text.secondary"
                  align="right"
                >
                  {formatItemDate(
                    (item.publishAt || item.createdAt) as string,
                    i18n.language
                  )}
                </Typography>
              </Box>
            ) : (
              <Typography variant="body2" color="text.primary" align="right">
                {t("shared.selectObject.notPublished", {
                  defaultValue: "Не опубликовано",
                })}
              </Typography>
            )}
          </Box>
        </Stack>
      </CardContent>
    </Card>
  );
};
